const apis = {
  tasks: `https://68893d5d4c55d5c73951f3df.mockapi.io`,
};

const getApiUrl = (apiName: keyof typeof apis) => {
  return apis[apiName];
};

export { getApiUrl };
